// extracted by mini-css-extract-plugin
export default {"collectionView":"CollectionView_collectionView__IMyxd"};